import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';

// Config.
import { OPTION_SHAPE } from '@/config/prop-types';

const Select = ({
  hiddenLabel,
  label,
  onChange,
  options,
  value,
}) => {
  const id = uuidv4();
  return (
    <div className="hst-filter__subset">
      <label htmlFor={id}>
        <span className={classnames({ 'screen-reader-text': hiddenLabel })}>
          {label}
        </span>
        <select id={id} onChange={({ target: { value: next } }) => onChange(next)}>
          {options.map((option) => (
            <option
              key={option.value}
              selected={option.value === value}
              value={option.value}
            >
              {option.label}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
};

Select.defaultProps = {
  hiddenLabel: false,
};

Select.propTypes = {
  hiddenLabel: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape(OPTION_SHAPE)).isRequired,
  value: PropTypes.string.isRequired,
};

export default Select;
